import { RelativeTimeUnits } from 'pounceV2';
import { SimpleQueryFormValues } from '../types';

// Preset values are single-unit ISO 8601 durations (matching the RelativeTimeDuration wire scalar);
// PAllTime is the all-time sentinel. RelativeTimeCustom/Custom are UI-only modes with no wire value.
export enum TimeFrameEnum {
  Last20Minutes = 'PT20M',
  LastHour = 'PT1H',
  Last3Hours = 'PT3H',
  Last6Hours = 'PT6H',
  Last12Hours = 'PT12H',
  Last24Hours = 'PT24H',
  Last3Days = 'P3D',
  LastWeek = 'P1W',
  LastMonth = 'P1M',
  Last3Months = 'P3M',
  Last6Months = 'P6M',
  AllTime = 'PAllTime',
  RelativeTimeCustom = 'customrelative',
  Custom = 'custom',
}

export type CrossLogSearchFormValues = Omit<SimpleQueryFormValues, 'table' | 'database'> & {
  databases: string[];
  tables: string[];
  timeFrame: TimeFrameEnum;
  relativeNumberVal?: number;
  relativeTimeUnit?: RelativeTimeUnits;
};

export enum FilterInputTypeEnum {
  Key = 'key',
  Operator = 'operator',
  Value = 'value',
}
